import { useQuery } from "@tanstack/react-query";
import { TestRowWithResult } from "../api/test.type";
import { getTest } from "../api/tests.api";

export default function useLoadTestById(testId: string) {
  const {
    data: test,
    isLoading,
    error,
  } = useQuery<TestRowWithResult>({
    queryKey: ["diagnostic-test", testId],
    queryFn: () => getTest(testId),
    enabled: !!testId,
  });

  return { test, isLoading, error };
}
